"use client";

import { useId } from "react";
import { InfoIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

export function InfoHint({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  const tooltipId = useId();

  return (
    <span className={cn("relative inline-block align-middle leading-none", className)}>
      <button
        type="button"
        aria-label={text}
        aria-describedby={tooltipId}
        className="peer inline-flex h-5 w-5 items-center justify-center rounded-full text-muted transition-colors duration-200 hover:bg-foreground/5 hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary/40"
      >
        <InfoIcon className="h-3.5 w-3.5" />
      </button>

      <span
        id={tooltipId}
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-30 mt-2 w-56 -translate-x-1/2 translate-y-1 rounded-md border border-border bg-background px-2.5 py-2 text-xs font-normal text-muted opacity-0 shadow-md transition-all duration-150 peer-hover:translate-y-0 peer-hover:opacity-100 peer-focus:translate-y-0 peer-focus:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
